import { NumberInput, Stack } from '@mantine/core'
import { useForm, zodResolver } from '@mantine/form'
import Form from 'common/Form'
import { PlaceConfig, placeConfigSchema } from 'types/places'

type NewProps = {
  onSubmit: (values: PlaceConfig) => void
  onCancel: () => void
  initialValues?: undefined
}

type UpdateProps = {
  onSubmit: (values: PlaceConfig) => void
  onCancel: () => void
  initialValues: PlaceConfig
}

type Props = NewProps | UpdateProps

export default function PlaceConfigForm({ initialValues, onSubmit, onCancel }: Props) {
  const form = useForm<PlaceConfig>({
    validate: zodResolver(placeConfigSchema),
    initialValues: initialValues
      ? {
          rack: initialValues.rack,
          numberOfColumns: initialValues.numberOfColumns,
          numberOfShelfes: initialValues.numberOfShelfes,
        }
      : {
          rack: null!,
          numberOfColumns: null!,
          numberOfShelfes: null!,
        },
  })

  return (
    <Form
      onSubmit={onSubmit}
      form={form}
      onCancel={onCancel}
      submitText={initialValues ? 'Zapisz zmiany' : 'Dodaj regał'}
    >
      <Stack gap="xs">
        <NumberInput
          label="Numer regału"
          description="Nie może się powtarzać z innym regałem."
          placeholder="3"
          withAsterisk
          allowNegative={false}
          allowDecimal={false}
          hideControls
          disabled={!!initialValues}
          {...form.getInputProps('rack')}
        />
        <NumberInput
          label="Liczba kolumn"
          description="Ile jest kolumn z półkami w tym regale?"
          placeholder="10"
          withAsterisk
          allowNegative={false}
          allowDecimal={false}
          hideControls
          {...form.getInputProps('numberOfColumns')}
        />
        <NumberInput
          label="Liczba półek"
          description="Ile jest półek w każdej kolumnie?"
          placeholder="6"
          withAsterisk
          allowNegative={false}
          allowDecimal={false}
          hideControls
          {...form.getInputProps('numberOfShelfes')}
        />
      </Stack>
    </Form>
  )
}
